import React from "react";
import {
  Button,
  Grid,
  Modal,
  MenuItem,
  Select,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Switch,
  Slider,
} from "@mui/material";
// import Chip from "@mui/material/Chip";
// import OutlinedInput from "@mui/material/OutlinedInput";
import { Calculate } from "@mui/icons-material";
// import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import {
  getChannels,
  getCategories,
  getOffers,
  getPromotions,
  getPayments,
  goodLeapCalc,
} from "../../Redux/Actions/goodLeapAction";
import { TotalAmount } from "../../Redux/Actions/CalculatorActions";
import axios from "axios";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import img from "../../assets/goodleapLogo.jpg";
import swal from "sweetalert";
import {
  getMosiacOffers,
  getMosiacPayments,
  mosiacCalc,
} from "../../Redux/Actions/MosaicAction";
import { set } from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "1rem",
  p: 4,
};

const ButtonStyled = styled(Button)`
  /* background: #ff9800; */
  background-color: #d26e04 I !important;
  background-image: linear-gradient(45deg, #d26e04 0%, #f7b334 100%) !important;
  border-radius: 2rem;
  padding: 0.8rem 2rem;
  width: 250px;
  margin: auto;
  &:hover {
    color: black !important;
  }
`;
const Img = styled.img`
  position: absolute;
  width: 10%;
  top: -5px;
  right: 0;
`;
const Mosiac = ({ servicId, disable }) => {
  const dispatch = useDispatch();
  const { singlead } = useSelector((state) => state.leads);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  // Get the data from Apis
  const { totalAmount } = useSelector((state) => state.calc);
  const { allOffers, payments, allMosiacData } = useSelector(
    (state) => state.Mosiac
  );
  console.log("allMosiacData", allMosiacData);
  console.log("payments", payments);
  const [data, setData] = React.useState({
    finance_product_id: "",
    loanAmount: "",
    mosaic_is_ach: true,
    pre_payment_amount: "",
    percentage: "",
  });
  const solarProduct = [
    { name: "Choice", value: "Choice" },
    { name: "Plus", value: "Plus" },
    // { name: "Light", value: "Light" },
    { name: "Zero", value: "Zero" },
    // {
    //   name: "ReducedRateApr",
    //   value: "ReducedRateApr",
    // },
    // { name: "DeferredInterest", value: "DeferredInterest" },
  ];
  React.useEffect(() => {
    dispatch(getMosiacOffers());
  }, []);
  React.useEffect(() => {
    dispatch(mosiacCalc({ ...data }));
  }, [data]);

  // React.useLayoutEffect(() => {
  //   let percent = (data?.pre_payment_amount / data?.loanAmount) * 100;
  //   setData({ ...data, percentage: percent });
  //   console.log(
  //     "percentpercentpercentpercentpercentpercentpercentpercent",
  //     percent
  //   );
  // }, [data?.pre_payment_amount]);

  const [value, setValue] = React.useState(30);
  let prePayment = (Number(value) * data?.loanAmount) / 100;

  // React.useLayoutEffect(() => {
  //   let preAmount = (data?.percentage / 100) * data?.loanAmount;
  //   setData({ ...data, pre_payment_amount: preAmount });
  // }, [value]);
  console.log("valuevaluevalue", value);
  const handleChange = (event, newValue) => {
    console.log("eventeventeventevent", event?.target.value);
    setValue(event?.target.value);
  };

  console.log("data data data data", data);
  console.log("allOffers", allOffers);
  const handleOpen = () => {
    setOpen(true);
    // dispatch(loadSunLightCalc());
  };
  // const filterration = () => {
  let filterOffers =
    allOffers?.filter((e) => e.financingProductType === data?.solar_product) ||
    [];
  // return filterOffers;
  // };

  // const TheOffer = allOffers?.find((e) => e.id == data.offers);

  let amount = totalAmount;
  const sendData = {
    finance_product_id: data.finance_product_id,
    principal: data.loanAmount,
    pre_payment_amount: prePayment,
    hasAchDiscount: data?.mosaic_is_ach,
  };
  // Submit Button
  const GetThePayment = (e) => {
    e.preventDefault();
    dispatch(getMosiacPayments(sendData));
    handleClose();
  };
  console.log("data", data);
  let CommaFormatted = (num) => {
    // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return Intl.NumberFormat("en-US").format(num);
  };
  return (
    <div>
      <ButtonStyled
        onClick={handleOpen}
        startIcon={<Calculate />}
        variant="contained"
        fullWidth
      >
        Mosaic Payment Calculator
      </ButtonStyled>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <div style={{ position: "relative" }}>
              <h2>Mosaic Payment Calculator</h2>
              <Img
                style={{ width: "10%" }}
                src="data:image/png;base64,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"
              ></Img>
            </div>
            <br />
            <br />
            <Grid item container spacing={2} columns={18} alignItems="center">
              {servicId === 1 ? (
                <>
                  <Tooltip
                    title="
If you are not paying by ACH (direct pay), your APR interest rate will be increased by 0.25%.
Your loan agreement will reflect the higher APR and corresponding payment information for paying
by a method other than ACH (direct pay)"
                    placement="top"
                  >
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <span>Without ACH</span>{" "}
                      <Switch
                        value={data.mosaic_is_ach}
                        onChange={(e) =>
                          setData({
                            ...data,
                            mosaic_is_ach: e.target.checked,
                          })
                        }
                        disabled
                        defaultChecked={data.mosaic_is_ach ? true : false}
                      />{" "}
                      <span>ACH (Direct pay)</span>
                    </Grid>
                  </Tooltip>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth className="formControl">
                      <InputLabel id="demo-simple-select-label">
                        Solar products
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        required
                        value={data.solar_product}
                        // disabled={disable}
                        label="Solar products"
                        onChange={async (e) => {
                          setData({
                            ...data,
                            solar_product: e.target.value,
                          });
                        }}
                      >
                        {solarProduct?.map((product) => (
                          <MenuItem key={product.value} value={product.value}>
                            {product?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth className="formControl">
                      <InputLabel id="demo-simple-select-label">
                        All Offers
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        required
                        value={data.finance_product_id}
                        // disabled={disable}
                        label="All Offers"
                        onChange={async (e) => {
                          setData({
                            ...data,
                            finance_product_id: e.target.value,
                          });
                        }}
                      >
                        {filterOffers?.map((offer) => (
                          <MenuItem key={offer.id} value={offer.id}>
                            {offer.totalPeriods / 12} Years Rate{" "}
                            {data.mosaic_is_ach ? (
                              <>{offer.rate} %</>
                            ) : (
                              <>{offer.rateWithoutAchDiscount} %</>
                            )}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <TextField
                        disabled
                        label="Project cost"
                        value={CommaFormatted(
                          (data.loanAmount = Math.ceil(totalAmount)) || ""
                        )}
                        onChange={(e) =>
                          setData({
                            ...data,
                            loanAmount: Number(e.target.value),
                          })
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <TextField
                        disabled
                        type="number"
                        label="Pre payment amount"
                        value={(Number(value) * data?.loanAmount) / 100}
                        // onChange={(e) =>
                        //   setData({
                        //     ...data,
                        //     pre_payment_amount:Number(value) * data?.loanAmount / 100,
                        //   })
                        // }
                      />
                    </FormControl>
                  </Grid>
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <TextField
                        // disabled
                        type="number"
                        label="pre payment percentage %"
                        value={Number(data?.percentage)}
                        onChange={(e) => {
                          setData({ ...data, percentage: e.target.value });
                        }}
                      />
                    </FormControl>
                  </Grid> */}
                  <Grid
                    item
                    md={6}
                    sm={9}
                    xs={18}
                    mb={3}
                    className="sliderContainer"
                  >
                    <FormControl fullWidth>
                      <span>I can pay this much extra by month 0.</span>
                      <Slider
                        aria-label="Volume"
                        label="pre payment percentage %"
                        value={value}
                        onChange={handleChange}
                        valueLabelDisplay="auto"
                        valueLabelFormat={`${value} %`}
                      />
                      {/* <span className="percentage">{value}</span>
                      <input
                        type="range"
                        min="1"
                        max="100"
                        className="slider"
                        id="myRange"
                        value={value}
                        onChange={handleChange}
                      />
                      <span></span> */}
                    </FormControl>
                  </Grid>
                </>
              ) : (
                <> </>
              )}
            </Grid>
            <Grid
              container
              xs={18}
              item
              alignItems="center"
              justifyContent="center"
            >
              <ButtonStyled
                onClick={GetThePayment}
                fullWidth
                type="submit"
                className="btnCalc"
                endIcon={<Calculate />}
                variant="contained"
              >
                Calculate
              </ButtonStyled>
            </Grid>
          </form>
        </Box>
      </Modal>
    </div>
  );
};
const BigSection = styled.div`
  .sliderContainer {
    position: relative;
  }
  .percentage {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
export default React.memo(Mosiac);
